/**
 * System Backup Service
 *
 * API calls for system backup management
 */

import api from '../utils/api';

const systemBackupService = {
  /**
   * Get backup config
   * @returns {Promise} Response data with backup config
   */
  getBackupConfig: async () => {
    return api.get('/backup-system');
  },

  /**
   * Save backup config
   * @param {Object} configData - Backup config data
   * @returns {Promise} Response data
   */
  saveBackupConfig: async (configData) => {
    return api.put('/backup-system', configData);
  },

  /**
   * Trigger manual backup
   * @returns {Promise} Response data
   */
  manualBackup: async () => {
    return api.post('/backup-system/manual');
  },

  /**
   * Get system backup logs list
   * @param {Object} params - Query parameters (page, size, filters)
   * @returns {Promise} Response data with backup logs list
   */
  getBackupLogs: async (params = {}) => {
    return api.get('/backup-system/logs', params);
  },

  /**
   * Restore backup
   * @param {number} id - Backup log ID
   * @returns {Promise} Response data
   */
  restoreBackup: async (id) => {
    return api.post(`/backup-system/${id}/restore`);
  },
};

export default systemBackupService;
